import React from "react";

import styles from "./FeedbackHeader.module.scss";

const FeedbackHeader = ({ title }) => {
  return (
    <div className={styles.containerWrapper}>
      <div className={styles.container}>
        <h1 className={styles.title}>{title}</h1>
      </div>
    </div>
  );
};

export default FeedbackHeader;
